export function getArrayVal(idxVal) {
    return Array.isArray(idxVal) ? idxVal : [idxVal];
}
//# sourceMappingURL=getArrayVal.js.map